import React from 'react';
import { Modal, Badge } from 'react-bootstrap';

const TradeDetailsModal = ({ show, onHide, trade }) => {
    if (!trade) return null;

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Trade Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="trade-details">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <h5>Basic Information</h5>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>Currency</td>
                                        <td>
                                            <Badge bg="primary">
                                                {trade?.symbol || 'N/A'}
                                            </Badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Direction</td>
                                        <td>
                                            <Badge bg={trade?.direction === 'buy' ? 'success' : 'danger'}>
                                                {(trade?.direction || 'unknown').toUpperCase()}
                                            </Badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Status</td>
                                        <td>
                                            <Badge bg={
                                                !trade?.status ? 'secondary' :
                                                trade.status === 'active' ? 'warning' : 
                                                trade.status === 'completed' ? 'success' :
                                                trade.status === 'cancelled' ? 'danger' : 'secondary'
                                            }>
                                                {(trade?.status || 'unknown').toUpperCase()}
                                            </Badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Date</td>
                                        <td>{trade?.openManualDate + ' ' + trade?.openManualTime}</td>
                                    </tr>
                                    <tr>
                                        <td>Close Date</td>
                                        <td>{trade?.closeManualDate + ' ' + (trade?.closeManualTime?.substring(0,5) || '')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6">
                            <h5>Price Information</h5>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>Quantity</td>
                                        <td>{trade?.quantity || 0}</td>
                                    </tr>
                                    <tr>
                                        <td>Open Value</td>
                                        <td>{trade?.entryPrice || '0.00'}</td>
                                    </tr>
                                    <tr>
                                        <td>Close Value</td>
                                        <td>{trade?.exitPrice || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td>Profit/Loss</td>
                                        <td className={(trade?.profitLoss || 0) >= 0 ? 'text-success' : 'text-danger'}>
                                            ${trade?.profitLoss || '0.00'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <h5>Result Information</h5>
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>Result</td>
                                        <td>
                                            {trade?.result ? (
                                                <Badge bg={trade.result === 'profit' ? 'success' : 'danger'}>
                                                    {trade.result.toUpperCase()}
                                                </Badge>
                                            ) : 'N/A'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TradeDetailsModal; 